import Dexie from 'dexie';
import {
  PendingSurveySubmission,
  Survey,
  SurveyAnswerResult,
} from '../entities/survey.entity';

export class SurveyDatabase extends Dexie {
  surveys!: Dexie.Table<Survey, string>;
  progress!: Dexie.Table<SurveyAnswerResult, string>;
  pendingSubmissions!: Dexie.Table<PendingSurveySubmission, number>;

  constructor() {
    super('SurveyDatabase');
    this.version(4).stores({
      surveys: 'eventUUID',
      progress: 'eventUUID',
    });
    this.version(5).stores({
      surveys: 'eventUUID',
      progress: 'eventUUID',
      pendingSubmissions: '++id, eventUUID, createdAt',
    });
    this.version(6)
      .stores({
        surveys: 'eventUUID',
        progress: 'eventUUID',
        pendingSubmissions: '++id, eventUUID, createdAt, status',
      })
      .upgrade((tx) => {
        return tx
          .table('pendingSubmissions')
          .toCollection()
          .modify((row: { status?: string }) => {
            if (!row.status) {
              row.status = 'pending';
            }
          });
      });
  }

  async clearAllSurveys(): Promise<void> {
    await this.surveys.clear();
    await this.progress.clear();
    await this.pendingSubmissions.clear();
  }

  async deleteDatabase(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.delete()
        .then(() => {
          resolve();
        })
        .catch((error) => {
          console.error('Could not delete database', error);
          reject(error);
        });
    });
  }
}
